import { __decorate } from "tslib";
import { field } from '@simonbackx/simple-encoding';
import { MembersBlob } from './members/MemberWithRegistrationsBlob.js';
import { User } from './User.js';
export class UserWithMembers extends User {
    members = MembersBlob.create({});
}
__decorate([
    field({ decoder: MembersBlob })
], UserWithMembers.prototype, "members", void 0);
//# sourceMappingURL=UserWithMembers.js.map